// extracted by mini-css-extract-plugin
module.exports = {"Events":"Events_Events__1XUCt","event":"Events_event__yC_Mk"};